module.exports = __webpack_public_path__ + "dc23549081c98e3c54791522dd691045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorSPARKLINGWINE.jpg
// module id = 1126
// module chunks = 1